export default "{\n    \"suspended\": \"Suspended\",\n    \"deactivated\": \"Deactivated\"\n}\n"